import React from 'react'
import { ListItem } from './ListItem'

const List = ({ data, category }) => {
	return (
		<div className="list-container">
			{data.map((d, i) => (
				<ListItem
					key={i}
					index={(i % 3) + 1}
					category={category}
					data={d}
					first={i === 0}
					last={data.length - 1 === i}
				/>
			))}

			<style jsx>{`
				.list-container {
					width: 100%;
					padding: 0 2.5rem;
				}

				@media (max-width: 769px), (pointer: coarse) {
					.list-container {
						padding: 0 20px;
					}
				}	

			`}</style>
		</div>
	)
}

export default List
